<template>
  <!-- 用户设置 -->
  <div class="account">
    <van-cell-group>
      <van-switch-cell v-model="checked" title="登录页展示学校Logo：" />
    </van-cell-group>
    <p class="tip">
      <span>锁定账户</span> 0代表不锁定
    </p>
    <p class="msg"><span>锁定账户前可重复登录次数：</span><van-stepper min="0" v-model="FailedLoginCount" /></p>

    <p class="tip">
      <span>锁定账户</span> 0代表不解锁
    </p>
    <p class="msg"><span>锁定锁定几小时后自动解锁：</span><van-stepper min="0" v-model="UserLockHours" /></p>
    <p class="tip">
      <span>自动退出</span> 0代表不退出
    </p>
    <p class="msg"><span>用户无论操作多少分钟后自动退出：</span><van-stepper min="0" v-model="AutomaticLogOutTime" /></p>
    <van-button type="default" @click="edit">修改</van-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      checked: true,
      FailedLoginCount:0,
      UserLockHours:0,
      AutomaticLogOutTime:0,
      AccountNumber:'',
      AccountName:'',
      Address:'',
      Icon:'',
      SYSAccountID:'',
      IsShowAccountName:'',
      BackgroundImage:''

    };
  },
  created() {
    this.getSys()
  },
  methods: {
    async getSys() {
      let res = await this.xyapi.get(this.xyMApi + "/base/api/Settings/GetSYSAccount")
      if (res.success) {
        this.FailedLoginCount = res.data.FailedLoginCount;
        this.UserLockHours = res.data.UserLockHours;
        this.AutomaticLogOutTime = res.data.AutomaticLogOutTime;
        this.AccountNumber = res.data.AccountNumber
        this.AccountName = res.data.AccountName
        this.Address = res.data.Address
        this.Icon = res.data.Icon
        this.SYSAccountID = res.data.SYSAccountID
        this.IsShowAccountName = res.data.IsShowAccountName
        this.BackgroundImage = res.data.BackgroundImage
        this.checked = res.data.IsShowIcon
      }
    },
    async edit() {
      let res = await this.xyapi.post(this.xyMApi +"/base/api/Settings/EditSYSAccount",{
        AccountNumber: this.AccountNumber,
        AccountName: this.AccountName,
        Address: this.Address,
        Icon: this.Icon,
        FailedLoginCount: this.FailedLoginCount,
        UserLockHours: this.UserLockHours,
        AutomaticLogOutTime: this.AutomaticLogOutTime,
        SYSAccountID: this.SYSAccountID,
        IsShowAccountName: this.IsShowAccountName,
        IsShowIcon: this.checked,
        BackgroundImage: this.BackgroundImage
      })
      if(res.success){
        this.xy.msgSuc('修改成功')
      }
    }
  },
};
</script>
<style lang="less" scoped>
.account {
  text-indent: 3%;
  .tip {
    display: block;
    height: 40px;
    line-height: 40px;
    margin-top: 15px;
    color: #9ea7b4;
    span {
      color: #555;
    }
  }
  .msg {
    display: flex;
    justify-content: space-between;
    height: 100px;
    line-height: 100px;
    background-color: #fff;
    margin-top: 15px;
    font-size: 28px;
    span{
      width:500px;
      padding-left: 8px;
    }
    .van-stepper{
      flex:1
    }
  }
  .van-button {
    display: block;
    width: 100%;
    height: 80px;
    line-height: 80px;
    color: #fff;
    font-weight: 700;
    font-size: 30px;
    font-weight: 400;
    margin: 10px auto 15px;
    text-align: center;
    border-radius: 10px;
    background: #4196ff !important;
  }
}
</style>
